import {
  OnePageCheckoutMachineContext,
  SignupEvent,
} from "./OnePageCheckout.machine";
import { createHeaders } from "@/utils/createHeaders";
import { PostHog } from "posthog-js";

const makeCreatePendingSession =
  (posthog: PostHog) =>
  async (context: OnePageCheckoutMachineContext, event: SignupEvent) => {
    const { slot, duration, mentor_info, access_token } = context;

    const given_name = event.data.given_name;
    const family_name = event.data.family_name;

    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/one_page_checkout/pending_session`,
      {
        headers: createHeaders(access_token),
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
          email: event.data.email,
          given_name,
          family_name,
          slot,
          duration,
          mentor_id: mentor_info.mentor_id,
          cost: mentor_info.cost,
        }),
      }
    );

    if (!response.ok) {
      const error = await response.json();
      console.error(error);
      throw new Error(error.message);
    }

    const { elapsed_time, pending_session_id, stripe_client_secret } =
      await response.json();

    posthog.capture("one_page_checkout: pending session created", {
      elapsed_time,
      pending_session_id,
    });

    return {
      stripe_client_secret,
      pending_session_id,
      family_name,
      given_name,
    };
  };

export { makeCreatePendingSession };
